<template>
  <div class="quiz-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>

    <div class="quiz-container">
      <div class="aalign-center">
        <my-pagination
          :items="questions"
          :doubt="doubt"
          v-model="currentQuestionIndex"
          class="aflex-1"
        >
        </my-pagination>

        <my-button
          type="outline-red"
          class="font-bold mr-2"
          @click="mapModal = true"
        >
          MAP SOAL</my-button
        >

        <my-button type="fill-red" class="font-bold" @click="finishQuiz()">
          AKHIRI</my-button
        >
      </div>

      <div class="quiz mt-3">
        <div class="quiz__left">
          <h4>Soal {{currentQuestionIndex+1}}</h4>
          <img
            :src="currentQuestion.gallery"
            alt="image" 
            class="mt-1" 
            v-if="currentQuestion.gallery"
          />
          <div
            v-katex="{expression: currentQuestion.question ? currentQuestion.question : ' ', options: { macros: {' ': '\\space '} }}"
            class="mt-4"
          ></div>
        </div>
        <div class="quiz__right">
          <vue-countdown ref="countdown" :time="timer" @end="abortQuiz()">
            <template slot-scope="props">
              <h5 class="text-right">
              {{ props.hours }} : {{ props.minutes }} : {{ props.seconds }}
            </h5>
            </template>
          </vue-countdown>
          
          <div
            class="aalign-start mb-4 quiz__option"
            :class="{
              'quiz__option--active': currentQuestion.givenAnswer === i
            }"
            v-for="(opt, i) in currentQuestion.option_json"
            :key="i"
            @click="selectOption(opt, i)"
          >
            <div class="quiz__key mr-3">
              {{ opt.key == 1 ? "A" : opt.key ==2 ? "B" : opt.key == 3 ? "C" : opt.key == 4 ? "D" : "E" }}
            </div>
            <div>
              <div
                v-katex="{expression: opt.option ? opt.option : ' ', options: { macros: {' ': '\\space '} }}"
              ></div>
              <img
                :src="opt.picture"
                alt="ans image"
                v-if="opt.picture"
                class="mt-2" 
                width="150"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="aspace-between aalign-center mt-4">
        <my-button type="fill-yellow" class="font-bold mb-2" v-if="doubt.includes(currentQuestionIndex+1)" @click="undoubtSign(currentQuestionIndex+1)">
          Hilangkan Ragu-Ragu
        </my-button>
        <my-button type="fill-yellow" class="font-bold mb-2" v-else @click="doubtSign(currentQuestionIndex+1)">
          Tandai Ragu-Ragu
        </my-button>
        
        <div class="aalign-center">
          <my-button
            class="mr-3 font-bold mb-2"
            type="fill-blue"
            @click="handlePreviousClick" 
            v-if="currentQuestionIndex > 0"
          >
            <fa-icon icon="arrow-left" class="mr-1"></fa-icon>
            Soal Sebelumnya
          </my-button>

          <my-button
            type="fill-blue"
            class="font-bold mb-2"
            @click="handleNextClick" 
            v-if="currentQuestionIndex < (questions.length-1)"
          >
            Soal Selanjutnya
            <fa-icon icon="arrow-right" class="ml-1"></fa-icon>
          </my-button>
        </div>
      </div>
    </div>

    <b-modal v-model="endModal" hide-footer hide-header centered>
      <modal-close @click="endModal = false"></modal-close>
      <div class="p-4 text-center">
        <img src="/img/icons/warningexam.png" alt="" />
        <h3 class="text-center mt-3">Selesaikan Ujian</h3>
        <p v-if="empty.length > 0">
          Kamu melewati nomor
          <span class="not-answered" v-for="(emp, i) in empty"> {{i < empty.length-1 && empty.length > 1 ? emp+', ': emp+''}}</span>
          <br />
          Apakah kamu yakin ingin mengakhiri paket soal ini?
        </p>
        <p v-else>
          Apakah kamu yakin ingin mengakhiri paket soal ini?
        </p>

        <my-button class="mr-2 mt-4" @click="handlePackageClick">
          Akhiri Paket Soal & Lanjut ke Paket Selanjutnya
        </my-button>
        <my-button class="mr-2 mt-4" @click="handleEndClick">
          Akhiri Tryout
        </my-button>

        <my-button @click="endModal = false" type="fill-blue">
          Batal
        </my-button>
      </div>
    </b-modal>

    <b-modal v-model="endForceModal" hide-footer hide-header centered no-close-on-backdrop>
      <div class="p-4 text-center">
        <img src="/img/icons/warningexam.png" alt="" />
        <h3 class="text-center mt-3">Selesaikan Exam</h3>
        <p v-if="empty.length > 0">
          Kamu melewati nomor
          <span class="not-answered" v-for="(emp, i) in empty"> {{i < empty.length-1 && empty.length > 1 ? emp+', ': emp+''}}</span>
          <br />
        </p>
        <p v-else>
        </p>

        <my-button class="mr-2 mt-4" type="fill-blue" @click="handleYaClick">
          Akhiri Paket Soal & Lanjut ke Paket Selanjutnya
        </my-button>
      </div>
    </b-modal>

    <b-modal v-model="mapModal" hide-footer hide-header centered>
      <modal-close @click="mapModal = false"></modal-close>
      <div class="p-4 pt-0 text-center">
        <h3 class="text-center">Map Soal</h3>
        <div class="map-soals mt-4">
          <div
            class="map-soal"
            v-for="(question, i) in questions"
            :key="i"
            :class="{
              'map-soal--active': currentQuestionIndex === i || doubt.includes(i+1),
              'map-soal--answered': question.givenAnswer > -1 && !doubt.includes(i+1)
            }"
            @click="
              currentQuestionIndex = i;
              mapModal = false;
            "
          >
            <strong v-show="currentQuestionIndex === i">{{ i + 1 }}</strong>
            <span v-show="currentQuestionIndex != i">{{ i + 1 }}</span>
          </div>
        </div>
        <br />
        <b-row class="mt-4">
          <b-col md="4">
            <div class="aalign-center">
              <div class="belum-disi"></div>
              Belum diisi
            </div>
          </b-col>

          <b-col md="4">
            <div class="aalign-center">
              <div class="sudah-diisi"></div>
              Sudah diisi
            </div>
          </b-col>

          <b-col md="4">
            <div class="aalign-center">
              <div class="ragu-ragu"></div>
              Ragu-ragu
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { questions } from "../../data/questions";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
// import Countdown from "../../components/countdown";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    VueCountdown
  },
  data() {
    return {
      showOverlay:false,
      endModal: false,
      endForceModal: false,
      currentQuestionIndex: 0,
      mapModal: false,
      questions: [],
      answer: [],
      empty: [],
      doubt: [],
      timer: 6000,
      props: {},
      package: {},
      nextPacakgeId: -1,
    };
  },
  watch: {
    $route: function(newVal) {
      this.nextPacakgeId = -1;
      var idx = this.tryout.package.findIndex(x=>x.id==this.$route.params.package);
      if(idx < this.tryout.package.length-1) {
        idx++;
        this.nextPacakgeId = this.tryout.package[idx].id;
      }
      this.getDetail();
    }
  },

  computed: {
    currentQuestion() {
      if(this.currentQuestionIndex >= 0 && this.currentQuestionIndex < this.questions.length) {
        return this.questions[this.currentQuestionIndex];
      } else {
        return {}
      }
    },
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
      overlay: types.OVERLAY,
      tryout: types.TRYOUT,
      ongoing: types.TRYOUT_ONGOING
    }),
    pagination() {
      return [
        {
          text: this.tryout.tryout_level,
          url: '#'
        },
        {
          text: this.tryout.name,
          url: '#'
        },
        {
          text: this.package.tryout_subject,
          url: '#'
        },
        {
          text: this.package.name,
          url: '#'
        }
      ]
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      if(this.ongoing) {
        if(!this.tryout.id) {
          this.tryoutDetail();
        }
        this.getDetail();
        var idx = this.tryout.package.findIndex(x=>x.id==this.$route.params.package);
        
        if(idx < this.tryout.package.length-1) {
          idx++;
          this.nextPacakgeId = this.tryout.package[idx].id;
        }
      } else {
        this.$router.push("/tryout/"+this.$route.params.tryout);
      }
    } else {
      var link = "/login"
      if(this.$route.params.tryout) {
        link += "?tryout=" + this.$route.params.tryout
      }
      this.$router.push(link);
    }
  },
  methods: {
    ...mapActions({
      getPackageDetail: types.START_TRYOUT_PACKAGE,
      endPackage: types.END_TRYOUT_PACKAGE,
      endTryout: types.END_TRYOUT,
      setOverlay: types.SET_OVERLAY,
      getTryoutDetail: types.GET_TRYOUT_DETAIL
    }),
    selectOption(opt, i) {
      this.currentQuestion.givenAnswer = i;
      this.answer[this.currentQuestionIndex].key = opt.key;
      this.answer[this.currentQuestionIndex].value = opt.value;
    },
    tryoutDetail() {
      if(this.$route.params.tryout) {
        this.getTryoutDetail(this.$route.params.tryout)
        .then(response => {
        }).catch(error => {
          this.showMessageBox(error, "Failed to get tryout", "danger");
        })
      } else {
        this.$router.push("/no-subject");
      }
    },
    doubtSign(numb) {
      this.doubt.push(numb);
    },
    undoubtSign(numb) {
      this.doubt.splice(this.doubt.indexOf(numb), 1);
    },
    finishQuiz(end=false) {
      this.empty = [];
      for (var i = 0; i < this.answer.length; i++) {
        if(this.answer[i].key==0) {
          this.empty.push(i+1);
        }
      }
      if(end) {
        this.endForceModal = true;
      } else {
        this.endModal = true;
      }
    },
    abortQuiz() {
      //this.handlePackageClick();
      this.finishQuiz(true);
    },
    getDetail() {
      this.setOverlay(true);
      this.getPackageDetail(this.$route.params.package)
      .then(response => {
        var res = response;
        this.package = {
          name: res.name,
          tryout_subject: res.tryout_subject
        };
        this.timer=res.time_limit*60*1000;
        for (var i = 0; i < res.questions.length; i++) {
          res.questions[i].givenAnswer = -1;
          this.answer[i] = {
            id: res.questions[i].id,
            key: 0,
            value: 0
          }
        }
        this.questions =  res.questions;
        this.setOverlay(false);
      }).catch(error => {
        this.setOverlay(false);
        this.showMessageBox(error, "Failed to get questions", "danger");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    },
    handleNextClick() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
      }
    },
    handlePreviousClick() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },
    handleYaClick() {
      this.handlePackageClick();
    },
    handlePackageClick() {
      this.setOverlay(true);
      var payload = {
        package_id: this.$route.params.package,
        tryout_result_id: this.ongoing,
        answer: this.answer,
        time: (this.timer/60/1000) - this.$refs.countdown.totalMinutes
      }
      this.endPackage(payload)
      .then(response => {
        this.setOverlay(false);
        this.endModal = false;
        this.endForceModal = false;
        if(this.nextPacakgeId != -1) {
          this.currentQuestionIndex = 0;
          this.answer = [];
          this.$router.push("/tryout/"+this.$route.params.tryout+"/package/"+this.nextPacakgeId);
        } else {
          this.saveEndTryout();
        }
      }).catch(error => {
        this.setOverlay(false);
        this.showMessageBox(error, "Failed to end tryout", "danger");
      })
    },
    handleEndClick() {
      this.nextPacakgeId = -1;
      this.handlePackageClick();
    }, 
    saveEndTryout() {
      this.setOverlay(true);
      var payload = {
        id: this.ongoing
      }
      this.endTryout(payload)
      .then(response => {
        this.setOverlay(false);
        this.$router.push("/tryout/result/"+response.id);
      }).catch(error => {
        this.setOverlay(false);
        this.showMessageBox(error, "Failed to end tryout", "danger");
      })
    }
  }
};
</script>

<style>
.quiz-container {
  padding: 22px 28px;
}

.quiz {
  background: #fff;
  min-height: 200px;
  display: flex;
  flex-wrap: wrap;
}

.quiz__left {
  flex: 1;
  border-right: 1px solid #e6e6e6;
  padding: 23px;
}

.quiz__right {
  flex: 1;
  padding: 23px;
}

.quiz__key {
  width: 24px;
  height: 24px;
  border: solid 1px #949494;
  border-radius: 24px;
  font-weight: 500;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quiz__option {
  cursor: pointer;
}

.quiz__option:hover {
  font-weight: bold;
  color: #009feb;
}

.quiz__option:hover .quiz__key {
  border-color: #009feb;
}

.quiz__option--active {
  font-weight: bold;
  color: #009feb;
}

.quiz__option--active .quiz__key {
  border-color: #009feb;
  background-color: #009feb;
  color: #fff;
  font-weight: bold;
}

span.not-answered {
  font-weight: bold;
  color: #ff216c;
}

.quiz img {
  max-width: 100%;
}

.map-soals {
  display: flex;
  justify-content: center;
  align-self: center;
  flex-wrap: wrap;
  padding: 0 55px;
}

.map-soal {
  width: 40px;
  height: 40px;
  border: solid 1px #dadada;
  background-color: #efefef;
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 500;
  color: #494949;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 8px;
  border-radius: 40px;
  cursor: pointer;
}

.map-soal--active {
  background-color: #fba74f;
  color: #fff;
}

.map-soal--answered {
  background-color: #009feb;
  color: #fff;
}

.belum-disi,
.ragu-ragu,
.sudah-diisi {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  border: solid 1px #dadada;
  background-color: #efefef;
  margin-right: 7px;
}

.ragu-ragu {
  background-color: #fba74f;
}

.sudah-diisi {
  background-color: #009feb;
}

@media only screen and (max-width: 768px) {
  .quiz {
    display: block;
  }
}
</style>
